import AuthService from "../login/auth.service";
import axios from "axios";
import { comprobantes, compromisoSocio } from "../../components/generico/utils/UrlAPI";

class PagoSepelioService {

  async pagoSepelio(_cuentaDebito, _importeEfectivo) {
    //falta numero de operacion
    var data = JSON.stringify({
      canal: "WEB",
      cuentaDebito: _cuentaDebito,
      importeDebito: _importeEfectivo
    });

    var config = {
      method: "post",
      url: compromisoSocio + "sepelio/pagoSepelio",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };

    return await axios(config);
  }


  async getPagareSepelio() {

    var config = {
      method: "get",
      url: compromisoSocio + "sepelio/pagareSepelio",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);
  }

  async descargarComprobante(titulo, nroOperacion, nroSocioTitular, cuenta, moneda, total, nroSolicitud, nombreEmpresa) {

    var _url = comprobantes + "comprobantes/compromisos/sepelio";

    var data = JSON.stringify({
      titulo,
      nroOperacion,
      nroSocioTitular,
      cuenta,
      moneda,
      total,
      nroSolicitud,
      nombreEmpresa
    });

    var config = {
      method: "post",
      url: _url,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);

  }
}
export default new PagoSepelioService();
